module.exports = __webpack_public_path__ + "static/img/materialsInfo32.837266e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo32.png
// module id = 0dja
// module chunks = 2